(function () {
  'use strict';

  if (window.__regionalInventoryLoaded) return;
  window.__regionalInventoryLoaded = true;

  // Region resolved server-side in js-variables.liquid → theme.market.region
  var REGION = (function () {
    var m = (window.theme && window.theme.market) || {};
    return String(m.region || 'eu').toLowerCase() === 'uk' ? 'uk' : 'eu';
  })();

  var STRINGS = (window.theme && window.theme.variantStrings) || {};

  function parseInventoryMap(container) {
    var el = container.querySelector('[data-regional-inventory]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); }
    catch (e) { console.warn('[regional-inventory] JSON parse error:', e); return null; }
  }

  function regionalStock(map, variantId) {
    if (!map || !variantId) return null;
    var entry = map[String(variantId)];
    if (!entry) return null;
    var n = parseInt(entry[REGION], 10);
    return isNaN(n) ? null : n;
  }

  function RegionalInventoryGate(productForm) {
    // The JSON data-regional-inventory is inside <product-form> itself
    this.map = parseInventoryMap(productForm);
    if (!this.map) return;

    this.btn     = productForm.querySelector('[name="add"]');
    this.idInput = productForm.querySelector('input[name="id"]');
    this.form    = productForm.querySelector('form');
    this.msg     = productForm.querySelector('[data-regional-inventory-message]');

    if (!this.btn || !this.idInput) return;

    var self = this;

    // ── MutationObserver ─────────────────────────────────────────────────────
    // Intercept ANY external re-enabling of the button (theme async fetch,
    // other scripts…). If regional stock is still 0, re-lock immediately.
    new MutationObserver(function () {
      if (!self.btn.hasAttribute('disabled')) {
        var stock = regionalStock(self.map, self.idInput.value);
        if (stock !== null && stock <= 0) self._lock();
      }
    }).observe(this.btn, { attributes: true, attributeFilter: ['disabled'] });

    // ── Variant change ───────────────────────────────────────────────────────
    // updateVariantInput() sets idInput.value then dispatches 'change' on it.
    this.idInput.addEventListener('change', function () {
      self._apply();
    });

    // ── Submit guard (capture phase) ─────────────────────────────────────────
    if (this.form) {
      this.form.addEventListener('submit', function (evt) {
        var stock = regionalStock(self.map, self.idInput.value);
        if (stock !== null && stock <= 0) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          self._lock();
        }
      }, true);
    }

    this._apply();
  }

  RegionalInventoryGate.prototype._apply = function () {
    var stock = regionalStock(this.map, this.idInput.value);
    if (stock === null) { this._unlock(); return; }
    if (stock <= 0)     { this._lock();   }
    else                { this._unlock(); }
  };

  RegionalInventoryGate.prototype._lock = function () {
    this.btn.setAttribute('disabled', 'disabled');
    this.btn.setAttribute('aria-disabled', 'true');
    this.btn.dataset.rgLocked = '1';
    this.btn.textContent = STRINGS.soldOut || 'Sold out';
    if (this.msg) this.msg.hidden = false;
  };

  RegionalInventoryGate.prototype._unlock = function () {
    // Only remove OUR lock — never touch a button disabled by the theme
    if (!this.btn.dataset.rgLocked) return;
    delete this.btn.dataset.rgLocked;
    this.btn.removeAttribute('disabled');
    this.btn.removeAttribute('aria-disabled');
    this.btn.textContent = this.btn.dataset.preOrder === 'true'
      ? (STRINGS.preOrder  || 'Pre-order')
      : (STRINGS.addToCart || 'Add to cart');
    if (this.msg) this.msg.hidden = true;
  };

  function init(root) {
    (root || document).querySelectorAll('product-form').forEach(function (pf) {
      if (pf.__rgGate) return;
      pf.__rgGate = new RegionalInventoryGate(pf);
    });
  }

  if (document.readyState !== 'loading') {
    init(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
